<template>
  <div class="tw-flex tw-space-x-2">
    <tooltip-hover
      v-for="(item, index) in allowedAuthMethods"
      :key="index"
      :text="
        $t('login_with', {
          service:
            item.type === PORTAL_STUDIO && ssoInfo[GAME_ID]
              ? ssoInfo[GAME_ID]?.name
              : item.label,
        })
      "
      position="top right"
    >
      <base-button
        primary
        icon-size="lg"
        class="hover:tw-opacity-80"
        :class="item.background"
        :icon="item.icon"
        :base-icon="item.baseIcon"
        :sr-only="`Log in with ${item.label}`"
        @click="login(item.type)"
      />
    </tooltip-hover>

    <teleport to="body">
      <login-email-modal
        :show="isModalOpen"
        @close:loginmodal="hideModal"
        @login:success="$emit('login:success')"
        @show:showloginoptions="hideModal"
      />
    </teleport>
  </div>
</template>

<script>
import LoginEmailModal from '@components/Modals/LoginEmailModal.vue'
import TooltipHover from '@components/Message/TooltipHover.vue'
import { LOGIN_METHODS, PORTAL_STUDIO } from '@config/auth.js'
import { AuthOptions, GAME_ID } from '@config/game.js'
import { useModal, useSSO } from '@composables'
export default {
  components: {
    LoginEmailModal,
    TooltipHover,
  },
  emits: ['login:success'],
  setup() {
    const { triggerModal, hideModal, isModalOpen } = useModal()
    const { ssoInfo, loginSSO } = useSSO()

    const allowedAuthMethods = LOGIN_METHODS.filter(
      (item) => AuthOptions.value[item.config]
    )

    async function login(type) {
      if (type === 'email') triggerModal()
      else loginSSO(type)
    }

    return {
      allowedAuthMethods,
      PORTAL_STUDIO,
      isModalOpen,
      hideModal,
      GAME_ID,
      ssoInfo,
      login,
    }
  },
}
</script>
